import React from 'react'
import { MDBView, MDBMask } from 'mdbreact'
import Slider from 'react-slick'
import { HashLink as Link } from 'react-router-hash-link';
//graphql
import { useQuery } from '@apollo/react-hooks'
import GET_RELATED_BLOGS from '../queries/blog/getRelatedBlogs'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProgressiveImage from 'react-progressive-image'
import FluidLoaderHalf from './loaders/FluidLoaderHalf'

const RelatedBlogs = ({blogID, category}) => {
    
    const { data, loading, error } = useQuery(GET_RELATED_BLOGS, { variables: { category: category, blogID: blogID } })
    
    if(loading) return <div className="pt-5"><FluidLoaderHalf/></div>
    if(error) return <p>{error.message}</p>

    const countSlides = data.blogs.length < 2 ? 1 : 2

    const settings = {
        dots: true,
        infinite: true,
        className: 'center',
        centerMode: true,
        speed: 500,
        slidesToShow: countSlides,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnHover: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnHover: true,
                }
            }
        ]
    };

    const allRelatedBlogs = data.blogs
    
    const relatedBlogs = allRelatedBlogs.map((blog)=>
        <div className="px-2">
            <Link smooth to={`/blog/${blog.id}#blog`}>
                <MDBView className="rounded z-depth-0 mb-lg-0 mb-4" waves>
                    <ProgressiveImage src={blog.preview.url} placeholder={blog.preview.formats.thumbnail.url}>
                    { (src, loading) => <img
                        className="img-fluid w-100"
                        style={{ filter: loading && "blur(10px)" }}
                        src={src}
                        alt=""
                    />}
                    </ProgressiveImage>
                    <a href="#readblog">    
                        <MDBMask overlay="black-strong flex-center">
                            <div className="text-center flex-column flex-center">
                                <h4 className="h4-responsive font-weight-bold w-75 white-text my-4">
                                    {blog.title}
                                </h4>
                                <h6 className="text-capitalize white-text link-underline h6-responsive">
                                    Read blog
                                </h6>
                            </div>
                        </MDBMask>
                    </a>
                </MDBView>
            </Link>
        </div>
    )
    
    return (
        <>
        <div className="pt-5 text-center">
            {data.blogs !== null && data.blogs.length > 0 ? <div className="related-blogs-container">
                <h2 className="h2-responsive font-weight-bold">
                    Related Articles
                </h2>
                <p className="grey-text mb-4">
                    These are blogs that you may like as well, these are also related
                </p>
                <Slider {...settings}>
                    {relatedBlogs}
                </Slider>
            </div>
            :
            <div className="text-center py-5">
                <h4 className="h4-responsive font-weight-bold text-uppercase">
                    Oooops, there are no related blogs yet
                </h4>
                <h6 className="h6-responsive">
                    Don't worry, the author will publish one soon. 
                </h6>
            </div>
            }
        </div>
        </>
    )
}

export default RelatedBlogs
